<template>
 <div class="finance-reports-menagers">
    <div class="finance-reports-menagers__filters d-flex my-3">
      <datepicker
        id="selectedStartDate"
        v-model="selectedStartDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
      >
      </datepicker>
      <datepicker
        id="selectedEndDate"
        v-model="selectedEndDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
        class="ml-2"
      >
      </datepicker>
      <select class="form-control custom-select ml-2" v-if="isDirector" v-model="selectedManagerId" id="managerId">
        <option v-for="manager in managers" :key="manager.name" :value="manager.id" :selected="manager.id === selectedManagerId">{{ manager.name }}</option>
      </select>
      <button @click="loadReport" class="btn btn-primary mx-3" :disabled="!isCanLoadReport">Применить</button>
    </div>
    <div class="finance-reports-menagers__report text-center my-5">
      <div class="finance-reports-menagers__report-row d-flex">
        <div class="finance-reports-menagers__report-column d-flex flex-column w-50">
          <div class="finance-reports-menagers__report-row d-flex justify-content-center">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--green rounded d-flex flex-column align-items-center w-100">
              <span class="pt-3">Сумма полностью оплаченных заказов</span>
              <span class="py-3">{{totalFullPaidTasks}}</span>
            </div>
          </div>
          <div class="finance-reports-menagers__report-row d-flex mt-1">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--orange rounded d-flex flex-column align-items-center">
              <span class="pt-3">Сумма полностью оплаченных заказов поставленных в этот период</span>
              <span class="py-3">{{totalFullPaidTasksSetInThisPeriod}}</span>
            </div>
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--gray rounded d-flex flex-column align-items-center ml-1">
              <span class="pt-3">Сумма полностью оплаченных заказов за прошлый период</span>
              <span class="py-3">{{totalFullPaidTasksPastPeriod}}</span>
            </div>
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--blue rounded d-flex flex-column align-items-center ml-1">
              <span class="pt-3">Сумма предоплаты на будущий период</span>
              <span class="py-3">{{totalPartPaidOnFeaturePeriod}}</span>
            </div>
        </div>
        </div>
        <div class="finance-reports-menagers__report-column d-flex flex-column flex-wrap w-25">
          <div class="finance-reports-menagers__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--gray rounded d-flex flex-column align-items-center w-100">
              <span class="pt-3 px-5">Общая сумма заказов</span>
              <span class="py-3">{{totalTasks}}</span>
            </div>
          </div>
          <div class="finance-reports-menagers__report-row d-flex justify-content-center h-50 ml-5">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--green rounded d-flex flex-column align-items-center mt-1 w-100">
              <span class="pt-3 px-5">Сумма поступлений</span>
              <span class="py-3">{{totalTransactions}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="finance-reports-menagers__report-row d-flex mt-5">
        <div class="finance-reports-menagers__report-column d-flex flex-column w-50">
          <div class="finance-reports-menagers__report-row mt-1 d-flex w-100">
            <div class="finance-reports-menagers__report-column d-flex flex-column mr-1 w-50">
              <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--gray rounded d-flex flex-column align-items-center w-100">
                <span class="pt-3">Cумма заказов по калькулятору</span>
                <span class="py-3">{{totalTasksCalc}}</span>
              </div>
              <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--green rounded d-flex flex-column align-items-center mt-1 w-100">
                <span class="pt-3">Cумма заказов по факту продаж</span>
                <span class="py-3">{{totalTasksFactSales}}</span>
              </div>
            </div>
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--blue rounded d-flex flex-column align-items-center justify-content-center w-50">
              <span class="pt-3">Разница</span>
              <span class="py-3">{{diff}}</span>
            </div>
          </div>
        </div>
        <div class="finance-reports-menagers__report-column d-flex flex-column flex-wrap w-25">
          <div class="finance-reports-menagers__report-row d-flex ml-5 h-100">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--green rounded d-flex flex-column align-items-center justify-content-center w-100">
              <span class="pt-3 px-5">Сумма быстрых сделок </span>
              <span class="py-3">{{totalQuickOrders}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="finance-reports-menagers__report-row d-flex mt-5">
        <div class="finance-reports-menagers__report-row d-flex w-50">
          <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--green rounded d-flex flex-column align-items-center mr-1 w-100">
            <span class="pt-3">Сумма свободных доходов<br>(транзакции без задачи)</span>
            <span class="py-3">{{totalFreeIncome}}</span>
          </div>
          <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--gray rounded d-flex flex-column align-items-center mr-1 w-100">
              <span class="pt-3">Сумма свободных расходов</span>
              <span class="py-3">{{totalFreeExpenses}}</span>
          </div>
          <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--red rounded d-flex flex-column align-items-center w-100">
              <span class="pt-3">Сумма отмененных транзакций</span>
              <span class="py-3">{{totalDisclaimTransactions}}</span>
          </div>
        </div>
        <div class="finance-reports-menagers__report-column d-flex flex-column flex-wrap w-25">
          <div class="finance-reports-menagers__report-row d-flex ml-5 h-100">
            <div class="finance-reports-menagers__report-block finance-reports-menagers__report-block--gray rounded d-flex flex-column align-items-center justify-content-center w-100">
              <span class="pt-3 px-5">Сумма отмененных заказов</span>
              <span class="py-3">{{totalDisclaimTasks}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../api'
import moment from 'moment'
import roles from '../../../../helpers/userRoles'
import datepicker from '../../../../components/datepicker.vue'
const today = new Date()
const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const demoFirstDate = new Date(2021, 0, 1)
const isDemo = location.host.indexOf('demo') >= 0
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(0)

const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export default {
  name: 'FinanceReportsMenagers',
  components: { datepicker },
  data () {
    return {
      users: [],
      maxDateForSelect: maxDate,
      minDateForSelect: minDate,
      selectedStartDate: isDemo ? demoFirstDate : firstDateOfMonth,
      selectedEndDate: today,
      selectedManagerId: null,
      isReportVisible: false,
      totalFullPaidTasks: null,
      totalFullPaidTasksSetInThisPeriod: null,
      totalFullPaidTasksPastPeriod: null,
      totalPartPaidOnFeaturePeriod: null,
      totalTasks: null,
      totalTransactions: null,
      totalDisclaimTasks: null,
      totalTasksCalc: null,
      totalTasksFactSales: null,
      diff: null,
      totalQuickOrders: null,
      totalFreeIncome: null,
      totalFreeExpenses: null,
      totalDisclaimTransactions: null
    }
  },
  computed: {
    managers () {
      const result = [{ id: null, name: 'Все менеджеры' }]
      const userForSelect = this.users.filter(
        x => x.roles === roles.director || x.roles === roles.manager
      )

      userForSelect.forEach(user => {
        result.push({ id: user.id, name: `${user.firstname} ${user.lastname}` })
      })

      return result
    },
    isCanLoadReport () {
      return this.selectedStartDate && this.selectedEndDate && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.selectedEndDate, 'DD-MM-YYYY')
    },
    isDirector () {
      return this.$store.getters.role === roles.director
    }
  },
  created () {
    Promise.all([this.loadUsers()])
  },
  methods: {
    async loadUsers () {
      try {
        const response = await api.get.users()
        this.users = response.data.data.users.filter(x => x.enabled)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadReport () {
      const filter = {
        start_date: moment(this.selectedStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        end_date: moment(this.selectedEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        manager: this.selectedManagerId === null ? undefined : this.selectedManagerId
      }
      try {
        const response = await api.post.reportManager(filter)
        const data = response.data.data
        this.isReportVisible = !!data.totalTasks
        this.totalFullPaidTasks = formatNumber(data.totalFullPaidTasks.toFixed(2))
        this.totalFullPaidTasksSetInThisPeriod = formatNumber(data.totalFullPaidTasksSetInThisPeriod.toFixed(2))
        this.totalFullPaidTasksPastPeriod = formatNumber(data.totalFullPaidTasksPastPeriod.toFixed(2))
        this.totalPartPaidOnFeaturePeriod = formatNumber(data.totalPartPaidOnFeaturePeriod.toFixed(2))
        this.totalTasks = formatNumber(data.totalTasks.toFixed(2))
        this.totalTransactions = formatNumber(data.totalTransactions.toFixed(2))
        this.totalDisclaimTasks = formatNumber(data.totalDisclaimTasks.toFixed(2))
        this.totalTasksCalc = formatNumber(data.totalTasksCalc.toFixed(2))
        this.totalTasksFactSales = formatNumber(data.totalTasksFactSales.toFixed(2))
        this.diff = formatNumber(data.diff.toFixed(2))
        this.totalQuickOrders = formatNumber(data.totalQuickOrders.toFixed(2))
        this.totalFreeIncome = formatNumber(data.totalFreeIncome.toFixed(2))
        this.totalFreeExpenses = formatNumber(data.totalFreeExpenses.toFixed(2))
        this.totalDisclaimTransactions = formatNumber(data.totalDisclaimTransactions.toFixed(2))
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.finance-reports-menagers {
  &__filters{
    .form-control{
      max-width: 250px;
    }
  }

  &__report-block {
    &--green {
      color: #28bd8b;
      background-color: lighten($color: #28bd8b, $amount: 40);
    }
     &--blue {
      color: #408fc2;
      background-color: lighten($color: #408fc2, $amount: 40);
    }
    &--orange {
      color: #e08e3c;
      background-color: lighten($color: #e08e3c, $amount: 40);
    }
    &--gray {
      color: #7b7c7d;
      background-color: lighten($color: #7b7c7d, $amount: 40);
    }
    &--red {
      color: #e84c3d;
      background-color: lighten($color: #e84c3d, $amount: 40);
    }
  }
}
</style>
